export default __webpack_public_path__ + "static/media/janko-pobeda.fa79abde.jpg";